/**
 * Consent mode mínimo (LGPD / privacidade).
 * Se analytics === false, não enfileira eventos (gate em enqueueEvent).
 */

const STORAGE_KEY = 'GOMARKE_CONSENT';

export interface ConsentState {
  analytics: boolean;
  marketing: boolean;
}

const DEFAULT_CONSENT: ConsentState = {
  analytics: true,
  marketing: true,
};

let inMemoryConsent: ConsentState | null = null;

function loadStored(): ConsentState {
  if (typeof window === 'undefined') return DEFAULT_CONSENT;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as unknown;
      if (
        parsed &&
        typeof parsed === 'object' &&
        'analytics' in parsed &&
        'marketing' in parsed
      ) {
        return {
          analytics: Boolean((parsed as ConsentState).analytics),
          marketing: Boolean((parsed as ConsentState).marketing),
        };
      }
    }
  } catch {
    // ignore
  }
  return DEFAULT_CONSENT;
}

function save(state: ConsentState): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // quota ou localStorage desabilitado
  }
}

/**
 * Define o estado de consent. Persiste em localStorage.
 */
export function setConsent(state: Partial<ConsentState>): void {
  const current = inMemoryConsent ?? loadStored();
  const next: ConsentState = {
    analytics: state.analytics ?? current.analytics,
    marketing: state.marketing ?? current.marketing,
  };
  inMemoryConsent = next;
  save(next);
}

/**
 * Retorna o estado atual de consent (memória ou localStorage).
 */
export function getConsent(): ConsentState {
  if (inMemoryConsent !== null) return inMemoryConsent;
  inMemoryConsent = loadStored();
  return inMemoryConsent;
}

/**
 * Retorna true se o rastreamento está permitido (analytics).
 * Usado como gate único antes de enfileirar qualquer evento.
 */
export function shouldTrack(): boolean {
  return getConsent().analytics;
}
